import React from "react";
import { useTranslation } from "react-i18next";

function AgeGroupsSection() {
  const { t } = useTranslation();

  const ageGroups = [
    {
      name: t("taolu_age_groups.group1.name"),
      ageRange: t("taolu_age_groups.group1.ageRange"),
      icon: "fas fa-child",
    },
    {
      name: t("taolu_age_groups.group2.name"),
      ageRange: t("taolu_age_groups.group2.ageRange"),
      icon: "fas fa-user-graduate",
    },
    {
      name: t("taolu_age_groups.group3.name"),
      ageRange: t("taolu_age_groups.group3.ageRange"),
      icon: "fas fa-user",
    },
    {
      name: t("taolu_age_groups.group4.name"),
      ageRange: t("taolu_age_groups.group4.ageRange"),
      icon: "fas fa-user-tie",
    },
    {
      name: t("taolu_age_groups.group5.name"),
      ageRange: t("taolu_age_groups.group5.ageRange"),
      icon: "fas fa-user-clock",
    },
  ];

  return (
    <section className="pt-12 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors" id="age-groups-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("taolu_age_groups.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed mt-6 max-w-3xl mx-auto">
            {t("taolu_age_groups.text")}
          </p>
        </div>

        {/* Age Groups Grid - Direct Cards without wrapper */}
        <div className="max-w-6xl mx-auto mb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {ageGroups.map((group, index) => (
              <div
                key={index}
                className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6 text-center hover:shadow-md transition-all duration-200 relative"
              >
                {/* Number Badge */}
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary dark:bg-primary-light flex items-center justify-center shadow-md">
                  <span className="text-white text-xs font-bold">{index + 1}</span>
                </div>

                <div className="flex flex-col items-center space-y-4">
                  {/* Icon */}
                  <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary/10 dark:bg-primary-light/20 flex items-center justify-center">
                    <i className={`${group.icon} text-primary dark:text-primary-light text-2xl`}></i>
                  </div>
                  
                  {/* Content */}
                  <div className="space-y-2">
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
                      {group.name}
                    </h3>
                    <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 dark:bg-primary-light/20">
                      <p className="text-sm text-primary dark:text-primary-light font-semibold">
                        {group.ageRange}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Note Text with decorative elements */}
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-center mb-4">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 to-slate-300 dark:from-transparent dark:via-slate-600 dark:to-slate-600"></div>
            <div className="mx-4">
              <svg
                className="w-4 h-4 text-slate-400 dark:text-slate-500"
                viewBox="0 0 8 8"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon points="4,0 8,4 4,8 0,4" />
              </svg>
            </div>
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-slate-300 to-slate-300 dark:from-transparent dark:via-slate-600 dark:to-slate-600"></div>
          </div>
          <p className="text-slate-600 dark:text-slate-400 text-base leading-relaxed text-center italic">
            {t("taolu_age_groups.note")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default AgeGroupsSection;

